import api from './api';

const ActivityService = {
    /** params: { jobId | clientId | userId, from, to, page, size } */
    list: (params) => api.get('/activity', { params }).then(r => r.data),
};

export default ActivityService;
